import { Skeleton } from "@/shared/ui";

export default function ProfilePageSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <div className="p-7 radius-3xl surface-base-fill flex items-center gap-4">
        <Skeleton circle width={64} height={64} />
        <div className="flex flex-col gap-2">
          <Skeleton width={220} height={24} borderRadius={8} />
          <Skeleton width={140} height={16} borderRadius={6} />
        </div>
      </div>

      <div className="p-6 radius-3xl surface-base-fill flex gap-2">
        <Skeleton width={120} height={36} borderRadius={6} />
        <Skeleton width={150} height={36} borderRadius={6} />
        <Skeleton width={110} height={36} borderRadius={6} />
      </div>

      <div className="p-7 radius-3xl surface-base-fill flex flex-col gap-4">
        <Skeleton width={180} height={20} borderRadius={6} />
        {Array.from({ length: 6 }).map(function renderRow(_, idx) {
          return (
            <div key={idx} className="flex items-center justify-between py-3">
              <Skeleton width={120} height={16} borderRadius={4} />
              <Skeleton width={160} height={16} borderRadius={4} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
